"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgLpg64 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M0 .5h64v64H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M23 16.094V8h18v8.094m0 34.687v5.781H23v-5.781m-1-34.687h20a5 5 0 0 1 5 5V45.78a5 5 0 0 1-5 5H22a5 5 0 0 1-5-5V21.094a5 5 0 0 1 5-5zm10 0v-4.047m-5 0h10m.874 25.384c-.473 2.98-2.647 5.14-5.286 5.25-2.468.114-4.66-1.557-5.344-4.04-.583-2.125-.124-4.457 1.405-7.13.2-.35.65-.992 1.049-1.546.017.098.037.194.06.286.173.685.4 1.349.875 1.568.288.134.747.142 1.262-.589 1.114-1.587 1.633-3.724 1.43-5.886 3.47 3.672 5.17 8.178 4.55 12.087z", stroke: "currentColor" })] })) }))); };
exports.default = SvgLpg64;
